import { AssetsResponse } from '../../entities/assets-v2';
import { DeviceWithAssetAndRadioData } from '../../entities/device-radios-v2/device-with-asset-and-radio-data-response';
import { Result } from './types';

export const createResultFromResponseForDevice = (
  response: DeviceWithAssetAndRadioData,
): Result => ({
  equipmentType: response.asset?.assetMake,
  moduleId: response.device.deviceSerialNumber,
  moduleType: response.device.deviceType,
  deviceId: response.device.deviceId,
  deviceKey: response.device.deviceKey,
  deviceType: response.device.deviceType,
  commercialType: response.device.commercialType,
  telematicsAssetId: response.asset?.telematicsAssetId,
  assetSerialNumber: response.asset?.assetSerialNumber,
  assetMake: response.asset?.assetMake,
  radioComponents: response.device.radioComponents,
  deviceSerialNumber: response.device.deviceSerialNumber,
  isTethered: response.device.isTethered,
  communicationMethod: response.device.radioComponents ?
    response.device.radioComponents[0]?.communicationMethod : null,
  response,
  deviceStatus: response.device.deviceStatus,
  orbcommType:response.device?.orbcommType,
  isTetheredToDeviceKey: response.device?.isTetheredToDeviceKey,
  deviceCharacterization: response.device?.deviceCharacterization,
  gpsRolloverStatus: response.device?.gpsRolloverStatus,
  createdTime: response.device?.createdTime,
  onboardApplicationMessageVersion: response.device?.onboardApplicationMessageVersion,
});

export const createResultFromDevicelessAsset = (response: AssetsResponse): Result => ({
  equipmentType: response.assetMake,
  moduleId: null,
  moduleType: null,
  deviceId: null,
  deviceKey: null,
  deviceType: null,
  commercialType: null,
  telematicsAssetId: response.telematicsAssetId,
  assetSerialNumber: response.assetSerialNumber,
  assetMake: response.assetMake,
  radioComponents: [],
  deviceSerialNumber: null,
  isTethered: false,
  communicationMethod: null,
  response,
  deviceStatus: null,
  orbcommType:null,
  isTetheredToDeviceKey: null,
  deviceCharacterization: null,
  gpsRolloverStatus: null,
  createdTime: null,
  onboardApplicationMessageVersion: null,
});

export const createResultFromResponseForAssetFromMaster = (
  response: AssetsResponse,
  iterator: number,
): Result => ({
  equipmentType: response.assetMake,
  moduleId: response.devices[iterator].deviceSerialNumber,
  moduleType: response.devices[iterator].deviceType,
  deviceId: response.devices[iterator].deviceId,
  deviceKey: response.devices[iterator].deviceKey,
  deviceType: response.devices[iterator].deviceType,
  commercialType: response.devices[iterator].commercialType,
  radioComponents: response.devices[iterator].radioComponents,
  telematicsAssetId: response.telematicsAssetId,
  assetSerialNumber: response.assetSerialNumber,
  assetMake: response.assetMake,
  deviceSerialNumber: response.devices[iterator].deviceSerialNumber,
  isTethered: response.devices[iterator].isTethered,
  communicationMethod: response.devices[iterator].radioComponents ?
    response.devices[iterator].radioComponents[0]?.communicationMethod : null,
  response,
  deviceStatus: response.devices[iterator].deviceStatus,
  orbcommType:response.devices[iterator]?.orbcommType,
  isTetheredToDeviceKey: response.devices[iterator]?.isTetheredToDeviceKey,
  deviceCharacterization: response.devices[iterator]?.deviceCharacterization,
  gpsRolloverStatus: response.devices[iterator]?.gpsRolloverStatus,
  createdTime: response.devices[iterator]?.createdTime,
  onboardApplicationMessageVersion: response.devices[iterator]?.onboardApplicationMessageVersion,
});

export const createResultFromResponseForAssetFromRadio = (
  response: AssetsResponse,
  iterator: number,
): Result => ({
  equipmentType: response.assetMake,
  moduleId: response.devices[0].radios[iterator].deviceSerialNumber,
  moduleType: response.devices[0].radios[iterator].deviceType,
  deviceId: response.devices[0].radios[iterator].deviceId,
  deviceKey: response.devices[0].radios[iterator].deviceKey,
  deviceType: response.devices[0].radios[iterator].deviceType,
  commercialType: response.devices[0].radios[iterator].commercialType,
  radioComponents: response.devices[0].radios[iterator].radioComponents,
  telematicsAssetId: response.telematicsAssetId,
  assetSerialNumber: response.assetSerialNumber,
  assetMake: response.assetMake,
  deviceSerialNumber: response.devices[0].radios[iterator].deviceSerialNumber,
  isTethered: true,
  communicationMethod: response.devices[0].radios[iterator].radioComponents ?
    response.devices[0].radios[iterator].radioComponents[0]?.communicationMethod : null,
  response,
  deviceStatus: response.devices[0].radios[iterator].deviceStatus,
  orbcommType:response.devices[0]?.orbcommType,
  isTetheredToDeviceKey: response.devices[0].radios[iterator]?.isTetheredToDeviceKey,
  deviceCharacterization: response.devices[0].radios[iterator]?.deviceCharacterization,
  gpsRolloverStatus: response.devices[0].radios[iterator]?.gpsRolloverStatus,
  createdTime: response.devices[0].radios[iterator]?.createdTime,
  onboardApplicationMessageVersion: response.devices[0].radios[iterator]?.onboardApplicationMessageVersion,

});

export const createResultFromResponseForDeviceFromRadio = (
  response: any,
  iterator: number,
): Result => ({
  equipmentType: response.asset?.assetMake,
  moduleId: response.device.radios[iterator].deviceSerialNumber,
  moduleType: response.device.radios[iterator].deviceType,
  deviceId: response.device.radios[iterator].deviceId,
  deviceKey: response.device.radios[iterator].deviceKey,
  deviceType: response.device.radios[iterator].deviceType,
  commercialType: response.device.radios[iterator].commercialType,
  radioComponents: response.device.radios[iterator].radioComponents,
  telematicsAssetId: response.telematicsAssetId,
  assetSerialNumber: response.asset?.assetSerialNumber,
  assetMake: response.asset?.assetMake,
  deviceSerialNumber: response.device.radios[iterator].deviceSerialNumber,
  isTethered: true,
  communicationMethod: response.device.radios[iterator].radioComponents ?
    response.device.radios[iterator].radioComponents[0]?.communicationMethod : null,
  response,
  deviceStatus: response.device.radios[iterator].deviceStatus,
  orbcommType:response.device?.orbcommType,
  isTetheredToDeviceKey: response.device.radios[iterator]?.isTetheredToDeviceKey,
  deviceCharacterization: response.device.radios[iterator]?.deviceCharacterization,
  gpsRolloverStatus: response.device.radios[iterator]?.gpsRolloverStatus,
  createdTime: response.device.radios[iterator]?.createdTime,
  onboardApplicationMessageVersion: response.device.radios[iterator]?.onboardApplicationMessageVersion,
});

export const createResultFromAssetForEcmDetails=(
  response: any,
  iterator: number,
): any => ({
  serialNumber:response.ecms[iterator].serialNumber,
  softwarePartNumber:response.ecms[iterator].softwarePartNumber,
  hardwarePartNumber:response.ecms[iterator].hardwarePartNumber,
  synchClockProtocolSupportedFlag:response.ecms[iterator].synchClockProtocolSupportedFlag,
  actingMasterECMFlag:response.ecms[iterator].actingMasterECMFlag,
  
});